module.exports = __webpack_public_path__ + "static/img/one.46995cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/18/one.png
// module id = 3619
// module chunks = 1